module.exports = __webpack_public_path__ + "img/nlic_gallery8.95b81df8.jpg";